import { WISE_ALIAS } from '../../resources/provider-constants';
const PAYPAL = 'paypal';
const WESTERN_UNION = 'western-union';
export const largestProviderByCountry = new Map([
    ['gb', [PAYPAL, WESTERN_UNION, 'hsbc', 'barclays', 'lloyds', 'moneygram', WISE_ALIAS]],
    ['us', [PAYPAL, WESTERN_UNION, 'chase', 'moneygram', 'wells-fargo', 'xoom', WISE_ALIAS]],
    ['au', [PAYPAL, WESTERN_UNION, 'commonwealth-bank-of-australia', 'anz', 'westpac', 'national-australia-bank', WISE_ALIAS]],
    ['hk', [PAYPAL, WESTERN_UNION, 'hang-seng', 'hsbc-hk', 'ocbc', 'ccb-hk', WISE_ALIAS]],
    ['es', [PAYPAL, WESTERN_UNION, 'lacaixa', 'bbva', 'sabadell', WISE_ALIAS]],
    ['nl', [PAYPAL, WESTERN_UNION, 'ing-nl', 'abn-amro-bank', 'rabobank', WISE_ALIAS]],
]);
